import FleetLayout from "layout/FleetLayout";
import FleetPage from "pages/dashboard/FleetPage";

export const fleetRoutes = {
    path: "fleet",
    element: <FleetLayout />,
    children: [
        {
            path: ":fleetId",
            element: <FleetPage />,
        },
    ],
};
